import { Injectable } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CustomValidator } from "src/app/shared/validators/custom-validator";



@Injectable({
    providedIn:'root'
})
export class ExternalEntityService{
    
    constructor(private formBuilder:FormBuilder){
    }

    getCreditDetailForm():FormGroup{
        return this.formBuilder.group({
          customerFlag:[false],
          customerApprovalStatus:[],//
          customerEntityLevel:[],
          customerCreditDays:[null],
          customerCreditAmount:[null],
          customerCategory:[null],
          customerCurrencyId:[null],
          customerCurrencyName:[null],
          vendorFlag:[false],
          vendorApprovalStatus:[],//
          vendorEntityLevel:[],
          vendorCreditDays:[null],
          vendorCreditAmount:[null],
          vendorCategory:[null],
          vendorCurrencyId:[null],
          vendorCurrencyName:[null],
        },{
          validator: this.checkRequired('customerFlag', 'vendorFlag')
        }
        )
    }

    checkRequired(controlName: string, matchingControlName: string) {
      return (formGroup: FormGroup) => {
          const control = formGroup.controls[controlName];
          const matchingControl = formGroup.controls[matchingControlName];

          if (!control.value && !matchingControl.value) {
              matchingControl.setErrors({ mustRequired: true });
          } else {
              matchingControl.setErrors(null);
          }
      }
    }  
    

    getContactDetailsForm(data?:any):FormGroup{
      return this.formBuilder.group({
        contactDetailsDto:this.formBuilder.array([])
      })
    }

    contactForm(data?:any){
      return this.formBuilder.group({
        id:[data?data.id:null],
        businessSegmentId:[data?data.businessSegmentId:null],
        businessSegmentName:[data?data.businessSegmentName:null],
        name:[data?data.name:null,[Validators.maxLength(100),Validators.pattern('^[a-zA-Z ]*$')]],
        email:[data?data.email:null,[Validators.maxLength(100),Validators.pattern("^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]],
        cellNumber:[data?data.cellNumber:null],
        departmentName:[data?data.departmentName:null],
        designationName:[data?data.designationName:null],
        decisionMaker:[data?data.decisionMaker:false,[Validators.required]],
        gatekeeper:[data?data.gatekeeper:false],
        coach:[data?data.coach:false],
        veto:[data?data.veto:false],
        leftOrganization:[data?data.leftOrganization:false],
        isWaAlert:[data?data.isWaAlert:false],
        isEmailAlert:[data?data.isEmailAlert:false],
        entityBranchId:[data?data.entityBranchId:null],
        entityBranchName:[data?data.entityBranchName:null]
      })
    }

    getGSTDetailsForm(){
      return this.formBuilder.group({
        taxDetialsDto:this.formBuilder.array([])
      });
    }

    
  
     branchTaxForm(data?:any){
      return this.formBuilder.group({
        id:[data?.id ?? null],
        gstNo:[data?.gstNo ?? null,[Validators.required,Validators.maxLength(15),Validators.pattern('^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$')]],
        description:[data?.description ?? null,[Validators.maxLength(200)]],
        clientId:[data?.clientId ?? null],
        companyId:[data?.companyId ?? null],
        entityBranchId:[data?.entityBranchId ?? null]
      })
    }

    getBranchCreditDetailsForm(): FormGroup {
      return this.formBuilder.group({
        branchCustomerCreditDetails: this.formBuilder.array([]),
        branchVendorCreditDetails: this.formBuilder.array([])
      });
    }

    branchCreditDetailForm(data?: any): FormGroup {
      return this.formBuilder.group({
        id: [data?.id ?? null],
        branchId: [data?.branchId ?? null],
        creditType: [data?.creditType ?? null],
        businessSegmentId: [data?.businessSegmentId ?? null],
        businessSegmentName: [data?.businessSegmentName ?? null],
        creditDays: [data?.creditDays ?? null, [Validators.pattern('^[1-9][0-9]*$')]],
        creditAmount: [data?.creditAmount ?? null, [Validators.pattern('^(?:[1-9][0-9]*(?:\\.[0-9]{1,2})?|0\\.(?:0[1-9]|[1-9][0-9]?))$')]],
        currencyId: [data?.currencyId ?? null],
        currencyName: [data?.currencyName ?? null]
      });
    }

    salesMappingForm(data?: any): FormGroup {
      return this.formBuilder.group({
        id: [data?.id ?? null],
        branchId: [data?.branchId ?? null],
        businessSegmentId: [data?.businessSegmentId ?? null, [Validators.required]],
        businessSegmentName: [data?.businessSegmentName ?? null],
        salesPersonId: [data?.salesPersonId ?? null],
        salesPersonName: [data?.salesPersonName ?? null],
        customerSupportId: [data?.customerSupportId ?? null],
        customerSupportName: [data?.customerSupportName ?? null]
      });
    }

}